// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__10TjJ","total":"Cart_total__3vZeL","actions":"Cart_actions__3OD2-","button--alt":"Cart_button--alt__34b5M","button":"Cart_button__24QLY"};